export function humbergerMenuButton(buttonEl, menuEl, textEl, sideEffectEls) {
  if ($(buttonEl).length) {
    $(buttonEl).on("click", function () {
      $(this).toggleClass("active");
      $(menuEl).slideToggle();
      if ($(this).find(textEl).text() !== "閉じる") {
        $(textEl).text("閉じる");
      } else {
        $(textEl).text("メニュー");
      }
      $(".l-wrapper").toggleClass("active");
      if (sideEffectEls.length) {
        sideEffectEls.map((el) => {
          $(el).toggleClass("active");
        });
      }
    });
  }
}
